import './Checkbox.scss';

const Checkbox = function (props) {
	let extraInfo = '';
	if (props.extraTokens) {
		extraInfo = (<span className="hint">{window?.t?.REQUIRES_EXTRA_CREDITS}</span>);
	}
	if (props.info) {
		extraInfo = (<span className="hint">{props.info}</span>);
	}
	return (
		<span className="checkbox">
		<input type="checkbox" value={props.value} id={props.name} checked={!!props.checked} onChange={props.onChange} />
		<label htmlFor={props.name}>{props.label}{extraInfo}</label>
		</span>
	);
}

export default Checkbox;